import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import Fade from "@mui/material/Fade";
import { Box, Typography, styled } from "@mui/material";
import Button from "../../components/Button";
import CustomTextField from "../../components/Textfield";
import { getSx } from "../../components/Modal/style";
import { useDispatch } from "react-redux";
import { showToast } from "../../store/slices/common";
import { validateEmail } from "../../utils";
import { inviteUser } from "../../http/auth";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Fade ref={ref} {...props} />;
});

const CustomDialog = styled(Dialog)(() => ({
  "& .MuiDialog-paper": {
    width: "400px",
    padding: "30px",
    borderRadius: "20px",
  },
  "& .MuiPaper-root": { maxWidth: "400px" },
  "& .MuiDialogActions-root": {},
}));

export default function CreateUser({ open, setOpen }) {
  const classes = getSx(true);
  const dispatch = useDispatch();
  const [email, setEmail] = React.useState("");

  const disabled = !validateEmail(email);

  const onChangeEmail = (event) => {
    setEmail(event.target.value);
  };

  const sendEmail = async () => {
    try {
      const res = await inviteUser({ email });
      if (res.status === 200) {
        dispatch(
          showToast({ msg: "Email sent successfully", color: "success" })
        );
      }
    } catch (error) {
      console.log(error, "error")
      dispatch(showToast({ msg: "Something went wrong", color: "error" }));
    }
    setEmail("");
    setOpen(false);
  };

  return (
    <CustomDialog
      open={open}
      keepMounted
      onClose={() => setOpen(false)}
      TransitionComponent={Transition}
      sx={{ "& .MuiPaper-root": { maxWidth: "400px" } }}
    >
      <DialogContent sx={{ padding: "8px 20px" }}>
        <Box sx={classes.subTitleContainer}>
          <Typography
            sx={{
              fontSize: "18px",
              minWidth: "300px",
              maxWidth: "400px",
            }}
          >
            Email<span style={{ color: "red" }}>*</span>
          </Typography>
          <CustomTextField
            sx={{
              width: "50%",
              minWidth: "300px",
              maxWidth: "400px",
            }}
            name="email"
            placeholder="Enter Email"
            value={email}
            onChange={onChangeEmail}
            type="text"
          />
        </Box>
      </DialogContent>
      <DialogActions
        disableSpacing={false}
        sx={{ ...classes.buttonWrapper, justifyContent: "center" }}
      >
        <Button
          style={classes.button}
          label="Create User"
          onClick={sendEmail}
          disabled={disabled}
        />
      </DialogActions>
    </CustomDialog>
  );
}
